import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum TimesheetSecurityRight {
    CanAccess = 6000,
    ManageMyTimesheets = 6001,
    ChangeStatus = 6002,
    ManageAllTimesheets = 6003

}

export class TimesheetSecurityModule extends BaseSecurityModule<TimesheetSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Timesheets,
            [
                { _id: TimesheetSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: TimesheetSecurityRight.ManageMyTimesheets, name: 'Manage My Timesheets', basic: true },
                { _id: TimesheetSecurityRight.ManageAllTimesheets, name: 'Manage All Timesheets', basic: false }
            ] as SecurityRight<TimesheetSecurityRight>[]
        );
    }


}
